if (!customElements.get('dm-collection-infinite-scroll')) {
  customElements.define('dm-collection-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('product-list');
      this.controls = this.querySelector('[data-load-controls]');
      this.button = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-load-status]');
      this.pagination = this.querySelector('[data-pagination-fallback]');
      this.nextUrl = this.getAttribute('next-url');
      this.sectionId = this.getAttribute('section-id');
      this.loading = false;
      this.paused = false;
      this.eventsController = new AbortController();
      const signal = this.eventsController.signal;
      this.button.addEventListener('click', () => this.loadNext(), { signal });
      document.addEventListener('facet:update', event => {
        if (event.detail.url.searchParams.get('section_id') !== this.sectionId) return;
        this.paused = true;
        this.requestController?.abort();
        this.observer?.disconnect();
      }, { signal });
      if (!('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '600px 0px' });
      this.pagination.hidden = true;
      if (this.nextUrl) {
        this.controls.hidden = false;
        this.button.hidden = false;
        this.observer.observe(this.controls);
      }
    }
    async loadNext() {
      if (this.loading || this.paused || !this.nextUrl) return;
      this.loading = true;
      this.button.disabled = true;
      this.status.textContent = 'Cargando más productos…';
      this.setAttribute('aria-busy', 'true');
      this.observer?.unobserve(this.controls);
      this.requestController = new AbortController();
      try {
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== new URL(window.location.href).origin) throw new Error('Invalid collection URL');
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url.toString(), { signal: this.requestController.signal });
        if (!response.ok) throw new Error('Collection page unavailable');
        const html = await response.text();
        if (this.paused || !this.isConnected || this.requestController.signal.aborted) return;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('dm-collection-infinite-scroll');
        const nextList = source?.querySelector('product-list');
        if (!nextList) throw new Error('Collection grid unavailable');
        const handles = new Set([...this.list.children].map(card => card.getAttribute('handle')).filter(Boolean));
        const cards = [...nextList.children].filter(card => {
          const handle = card.getAttribute('handle');
          if (card.tagName !== 'PRODUCT-CARD' || !handle || handles.has(handle)) return false;
          handles.add(handle);
          card.removeAttribute('reveal-on-scroll');
          card.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });
          return true;
        });
        const nextUrl = source.getAttribute('next-url');
        if (nextUrl && nextUrl === this.nextUrl) throw new Error('Collection page did not advance');
        this.list.append(...cards);
        const nextPagination = source.querySelector('[data-pagination-fallback]');
        if (nextPagination) this.pagination.innerHTML = nextPagination.innerHTML;
        this.nextUrl = nextUrl;
        this.pagination.hidden = true;
        this.status.textContent = this.nextUrl ? '' : 'Has visto todos los productos.';
        this.button.textContent = 'Ver más productos';
        this.button.hidden = !this.nextUrl;
        if (this.nextUrl) this.observer?.observe(this.controls);
      } catch (error) {
        if (error.name === 'AbortError' || this.paused || !this.isConnected) return;
        this.status.textContent = 'No se han podido cargar más productos.';
        this.button.textContent = 'Reintentar';
        this.pagination.hidden = false;
      } finally {
        this.loading = false;
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.paused = true;
      this.eventsController?.abort();
      this.requestController?.abort();
      this.observer?.disconnect();
    }
  });
}
